module.exports = __webpack_public_path__ + "static/media/Boas-Vindas.77aacbff.jpg";